import { render, staticRenderFns } from "./SpyderLinkedInIcon.vue?vue&type=template&id=23d1aa2f"
import script from "./SpyderLinkedInIcon.vue?vue&type=script&lang=js"
export * from "./SpyderLinkedInIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports